import { render } from "./HomeDimensiones.vue?vue&type=template&id=5bf39e6e"
import script from "./HomeDimensiones.vue?vue&type=script&lang=js"
export * from "./HomeDimensiones.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__